import type { AIAssistantConfig } from '@amzn/wwasft-components';
import { getCurrentEnvironment } from 'src/api/clients/config';

const AVAILABLE_AGENTS: AIAssistantConfig['availableAgents'] = [
  {
    id: 'store_finance_agent',
    name: 'Store Finance',
    appId: 'store_finance',
    description: 'Store-level financial insights and analysis',
  },
];

const QUICK_PROMPTS_BY_AGENT: AIAssistantConfig['quickPromptsByAgent'] = {
  store_finance_agent: [
    { text: 'What is GRC 5253?', fullPrompt: 'What is GRC 5253?' },
    {
      text: 'Evidence requirements for GRC 5254',
      fullPrompt: 'What evidence do I need for GRC 5254 quarterly review?',
    },
    {
      text: 'ALCD lease commencement process',
      fullPrompt: 'What is the ALCD process for lease commencement dates?',
    },
  ],
};

const STAGE_URLS: Record<string, { socketUrl: string; serviceUrl: string }> = {
  alpha: {
    socketUrl: 'wss://us-east-1-alpha-chat-ws.atlas.taxaudits.amazon.dev',
    serviceUrl: 'https://us-east-1-alpha-chat-rest.atlas.taxaudits.amazon.dev/api/v1/',
  },
  beta: {
    socketUrl: 'wss://us-east-1-beta-chat-ws.atlas.taxaudits.amazon.dev',
    serviceUrl: 'https://us-east-1-beta-chat-rest.atlas.taxaudits.amazon.dev/api/v1/',
  },
  gamma: {
    socketUrl: 'wss://us-east-1-gamma-chat-ws.atlas.taxaudits.amazon.dev',
    serviceUrl: 'https://us-east-1-gamma-chat-rest.atlas.taxaudits.amazon.dev/api/v1/',
  },
  prod: {
    socketUrl: 'wss://us-east-1-prod-chat-ws.atlas.taxaudits.amazon.dev',
    serviceUrl: 'https://us-east-1-prod-chat-rest.atlas.taxaudits.amazon.dev/api/v1/',
  },
};

const DISCLAIMER = {
  text: 'You may need to verify responses for accuracy.',
  linkText: 'FinSpace AI Assistant T&C',
  linkUrl:
    'https://w.amazon.com/bin/view/WWCF_IPAT/FinTech/CoreEngineering/Teams/FinSpace/AIAssistantT&C',
};

const DEFAULT_STAGE = 'beta';

type AIAssistantEnvConfig = Pick<
  AIAssistantConfig,
  'socketUrl' | 'serviceUrl' | 'quickPromptsByAgent' | 'title' | 'availableAgents' | 'disclaimer'
>;

export const getAIAssistantConfig = (): AIAssistantEnvConfig => {
  const stage = getCurrentEnvironment() || DEFAULT_STAGE;
  const urls = STAGE_URLS[stage] || STAGE_URLS[DEFAULT_STAGE];
  return {
    title: 'Controllership Intelligent Assistant (CIA)',
    quickPromptsByAgent: QUICK_PROMPTS_BY_AGENT,
    disclaimer: DISCLAIMER,
    ...urls,
    availableAgents: AVAILABLE_AGENTS,
  };
};
